import { jsx } from 'react/jsx-runtime';
import { DialogTitle } from '../../../../node_modules/@radix-ui/react-dialog/dist/index.js';
import classnames from '../../../../node_modules/classnames/index.js';
import { Children, isValidElement } from 'react';
import modules_e1204c3b from './CustomHeader.module.scss.js';
import { Wrap } from '../../../../shared/components/Wrap/Wrap.js';

const CustomHeader = ({ children, className }) => {
    /**
     * Radix 'Dialog' requires the presence of a 'DialogTitle' component. Naturally,
     * we would simply wrap the children in a 'DialogTitle' component, but we also
     * use the 'CustomHeader' component in our 'Header' component, which already
     * wraps the children in a DialogTitle component, but in a more targeted way,
     * for better accessibility. Therefore, we need to check if the children
     * passed in are of the 'Header' type, in order not to wrap it twice, and have
     * duplicate IDs.
     */
    const hasTitle = Children.toArray(children).some((child) => isValidElement(child) && child.props["data-header"]);
    return (jsx(Wrap, { if: !hasTitle, render: (wrappedChildren) => (jsx(DialogTitle, { asChild: true, children: wrappedChildren })), children: jsx("header", { className: classnames(modules_e1204c3b.header, className), children: children }) }));
};

export { CustomHeader };
//# sourceMappingURL=CustomHeader.js.map
